var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 75,
    viewBox: "0 0 79 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.75 58.125C76.5114 58.125 78.75 55.8864 78.75 53.125V5C78.75 2.23857 76.5114 0 73.75 0H5C2.23858 0 0 2.23858 0 5V53.125C0 55.8864 2.23858 58.125 5 58.125H34.6875V67.1875H22.8125V74.0625H55.9375V67.1875H44.0625V58.125H73.75ZM5.3125 10.3125C5.3125 7.55108 7.55108 5.3125 10.3125 5.3125H68.125C70.8864 5.3125 73.125 7.55108 73.125 10.3125V47.5C73.125 50.2614 70.8864 52.5 68.125 52.5H10.3125C7.55108 52.5 5.3125 50.2614 5.3125 47.5V10.3125ZM39.3903 31.6763L38.7412 31.4291L28.2472 27.5034V37.1166C28.2472 39.1875 33.2238 40.8722 39.375 40.8722C45.5262 40.8722 50.5028 39.1875 50.5028 37.1166V27.5034L40.0397 31.4291L39.3903 31.6763ZM24.5225 24.1187V36.0656C25.2644 36.4056 25.7744 37.1628 25.7744 38.0438V43.2984H21.4469V38.0438C21.4469 37.1781 21.9569 36.4209 22.6834 36.0809V23.4387L19.5925 22.2797L39.3906 14.8612L59.1578 22.2797L39.3906 29.6981L24.5225 24.1187Z",
    fill: "#FB2E01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).052553a61d520255d8de54c723fbf5c2.svg";
export { ForwardRef as ReactComponent };